import React, { useState } from 'react';
import { Box, Collapse, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { STATUS_COLOR } from './statusColors';

const GROUPS = [
  { key: 'added', label: 'Added' },
  { key: 'removed', label: 'Removed' },
  { key: 'changed', label: 'Changed' },
  { key: 'unchanged', label: 'Unchanged' },
];

// Shared "Added/Removed/Changed/Unchanged" collapsible grouping -- used for
// both the node list and the edge list, which only differ in row rendering.
export default function GroupedStatusList({ title, items, isForcedOpen, renderItem }) {
  const [openGroups, setOpenGroups] = useState({ added: true, removed: true, changed: true, unchanged: false });
  const byStatus = { added: [], removed: [], changed: [], unchanged: [] };
  for (const item of items) byStatus[item.status].push(item);

  return (
    <Box sx={{ mb: 3 }}>
      <Typography sx={{ fontSize: 17, fontWeight: 700, mb: 1.5 }}>
        {title} ({items.length})
      </Typography>
      {GROUPS.map(({ key, label }) => {
        const groupItems = byStatus[key];
        if (!groupItems.length) return null;
        // Auto-reveal a group a jump-link just expanded into, even if collapsed.
        const open = openGroups[key] || (isForcedOpen && groupItems.some(isForcedOpen));
        return (
          <Box key={key} sx={{ mb: 1.5, bgcolor: `${STATUS_COLOR[key]}14`, border: '1px solid', borderColor: STATUS_COLOR[key], borderRadius: 2, p: 1 }}>
            <Box
              onClick={() => setOpenGroups((prev) => ({ ...prev, [key]: !prev[key] }))}
              sx={{ display: 'flex', alignItems: 'center', gap: 0.75, cursor: 'pointer', py: 0.4 }}
            >
              <ExpandMoreIcon sx={{ fontSize: 20, color: STATUS_COLOR[key], transform: open ? 'rotate(180deg)' : 'none', transition: 'transform .1s' }} />
              <Typography sx={{ fontSize: 14, fontWeight: 700, color: STATUS_COLOR[key] }}>{label} ({groupItems.length})</Typography>
            </Box>
            <Collapse in={open}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75, pt: 0.75 }}>
                {groupItems.map(renderItem)}
              </Box>
            </Collapse>
          </Box>
        );
      })}
    </Box>
  );
}
